import TrimbleMaps from "@trimblemaps/trimblemaps-js"
import MapConstant from "./mapconstants"
import {STYLES} from "../styles/theme"
import { point as turfPoint, distance as turfDistance } from '@turf/turf';

export default class MapHelper {
  static config ={
    accessKey: "",
    theme:{},
    country: "",
    geoCodeUrl: ""
  }

  static styles = {
    modernLight: "",
    modernDark: ""
  }

  static updateStyleKey = (style, mapConfig) => {
    const styleString = JSON.stringify(style);
    let updatedStyle = styleString.replaceAll(
      "key=customKey",
      `key=${mapConfig.accessKey}`
    );
    updatedStyle = updatedStyle.replaceAll(
      "authToken=customKey",
      `authToken=${mapConfig.accessKey}`
    );
    updatedStyle = JSON.parse(updatedStyle);
    if (!mapConfig.enableTrafficWeatherLayer && updatedStyle.sources) { 
      const {WeatherAlerts=null, WeatherCloud=null, Traffic=null, ...others} = updatedStyle.sources
      updatedStyle = {
        ...updatedStyle,
        sources: others,
        layers: updatedStyle.layers.filter(
          (layer) =>
            !(layer.id?.includes("weather") || layer.id?.includes("traffic"))
        ),
      };
    }
    return updatedStyle;
  }; //ToDo - added a null check here once we get access will test update code accordingly

  static setConfig = (config) => {
    MapHelper.config = config;
    MapHelper.config.theme={
      "modernLight": "datalight",
      "modernDark": "datadark",
      "satellite": "satellite"
    }
    MapHelper.styles.datalight = MapHelper?.styles?.datalight || MapHelper.updateStyleKey(STYLES.datalight, MapHelper.config)
    MapHelper.styles.datadark = MapHelper?.styles?.datadark || MapHelper.updateStyleKey(STYLES.datadark, MapHelper.config)
  }

  static getMapStyle = (themeName) => {
    const styleName = MapHelper.config.theme[themeName];
   return  MapHelper.styles[styleName] || styleName || MapHelper.config.modernLight;
  };

  static getKey = () => {
    return MapHelper.config.accessKey;
  };

  static getGeoCodingAPIEndPoint = () => {
    return MapHelper.config.geoCodeUrl;
  };

  static getCountry = () => {
    return MapHelper.config.country;
  };

  static getDistance =  (points) => {
    const stopPoints  = points.map(point => point.join(",")).join(";");
    return fetch(`https://pcmiler.alk.com/apis/rest/v1.0/Service.svc/route/routeReports?stops=${stopPoints}&reports=Mileage&vehType=${TrimbleMaps.Common.VehicleType.TRUCK}&vehDimUnits=${TrimbleMaps.Common.TruckUnit.METRIC}&vehHeight=${MapConstant.truckProfile.costing_options.height}&vehLength=${MapConstant.truckProfile.costing_options.length}&vehWidth=${MapConstant.truckProfile.costing_options.width}&vehWeight=${MapConstant.truckProfile.costing_options.weight}&hazMat=${TrimbleMaps.Common.HazMatType.GENERAL}`,
        {headers:{authorization:MapHelper.getKey()}})
        .then(response => response.json())
        .then(data => {
          const { TMiles, THours} = data[0].ReportLines[data[0].ReportLines.length-1];
          if(TMiles && THours){
            const [hour, mins] = THours.split(":");
            return { distance: TMiles, duration: Number(hour) * 60 + Number(mins)}
          }
          return null   
        }).catch(error =>  null)
  };
  static getGeoMaxDistanceMiles = (points)=> {
    if (!points || points.length < 2) return 0;
    let maxMiles = 0;
    for (let i = 0; i < points.length; i++) {
      const p1 = turfPoint(points[i]); // [lng, lat]
      for (let j = i + 1; j < points.length; j++) {
        const p2 = turfPoint(points[j]);
        const miles = turfDistance(p1, p2, { units: 'miles' });
        if (miles > maxMiles) maxMiles = miles;
      }
    }
    return maxMiles;
  }
}